/* eslint-disable no-alert */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TextArea, Button, Header, Input, Checkbox, Form } from 'semantic-ui-react'
import moment from 'moment'
import firebase from '../../../config/firebase'

class OrderConfiguration extends Component {
  state = {
    loading: true,
    updating: false,
    hasChange: false,
    blockOrder: {
      enable: true,
      title: {
        en: '',
        kh: '',
      },
      description: {
        en: '',
        kh: '',
      },
    },
  }

  componentDidMount() {
    const { region } = this.props

    this.orderRequestSubscribe = firebase.database().ref(`configs/${region.id}/order_traffic_configs/block_order`)

    this.orderRequestSubscribe.on('value', snapshot => {
      const blockOrder = snapshot.val() || {}

      this.setState({
        loading: false,
        blockOrder,
      })
    })
  }

  componentWillUnmount() {
    if (this.orderRequestSubscribe) {
      this.orderRequestSubscribe.off()
    }
  }

  onChangeText = (field, locale, value) => {
    const { blockOrder } = this.state

    this.setState({
      blockOrder: {
        ...blockOrder,
        [field]: {
          ...blockOrder[field],
          [locale]: value,
        },
      },
      hasChange: true,
    })
  }

  onChangeStatus = value => {
    const { blockOrder } = this.state

    this.setState({
      blockOrder: {
        ...blockOrder,
        enable: value,
      },
      hasChange: true,
    })
  }

  onSubmit = async () => {
    const confirmation = window.confirm('Are you sure to make a change?')

    if (!confirmation) return

    this.setState({ updating: true })

    const { blockOrder } = this.state
    const { region, auth: { username, uid } } = this.props

    const updates = {}

    const logId = firebase.database().ref(`configs/${region.id}/logs`).push().key
    const logData = {
      handler: username,
      handler_uid: uid,
      block_order: blockOrder.enable,
      created_at: Number(moment().format('x'))
    }

    // For older Muuve app version
    if (region.id === 'pnh') {
      updates[`configs/block_order`] = {
        blocked: blockOrder.enable,
        title: blockOrder.title,
        description: blockOrder.description,
      }
    }

    // For older Muuve app version
    updates[`configs/${region.id}/block_order`] = {
      blocked: blockOrder.enable,
      title: blockOrder.title,
      description: blockOrder.description,
    }

    updates[`configs/${region.id}/logs/${logId}`] = logData
    updates[`configs/${region.id}/order_traffic_configs/block_order`] = blockOrder

    const err = await firebase.database().ref().update(updates)

    if (err) alert(err)

    this.setState({ updating: false, hasChange: false })
  }

  render() {
    const { region } = this.props
    const { updating, loading, blockOrder, hasChange } = this.state

    return (
      <div className="configuration-tab">
        <Header size="large">{region.name}</Header>
        <Form loading={updating || loading} onSubmit={this.onSubmit}>
          <Form.Field
            control={Checkbox}
            label={`Order request is ${blockOrder.enable ? 'Blocked' : 'Available'}`}
            checked={!blockOrder.enable}
            toggle
            required
            onChange={() => this.onChangeStatus(!blockOrder.enable)}
          />
          <Form.Group widths="equal">
            <Form.Field
              control={Input}
              required
              value={blockOrder.title ? blockOrder.title.en : ''}
              label="Title in English"
              placeholder="Block order request title in english"
              onChange={e => this.onChangeText('title', 'en', e.target.value)}
            />
            <Form.Field
              control={Input}
              required
              value={blockOrder.title ? blockOrder.title.kh : ''}
              label="Title in Khmer"
              placeholder="Block order request title in khmer"
              onChange={e => this.onChangeText('title', 'kh', e.target.value)}
            />
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field
              control={TextArea}
              required
              value={blockOrder.description ? blockOrder.description.en : ''}
              label="Description in English"
              placeholder="Block order request description in english"
              onChange={e => this.onChangeText('description', 'en', e.target.value)}
            />
            <Form.Field
              control={TextArea}
              required
              value={blockOrder.description ? blockOrder.description.kh : ''}
              label="Description in Khmer"
              placeholder="Block order request description in khmer"
              onChange={e => this.onChangeText('description', 'kh', e.target.value)}
            />
          </Form.Group>
          <Button type="submit" disabled={!hasChange}>
            Save
          </Button>
        </Form>
      </div>
    )
  }
}

const mapState = ({ auth }) => ({
  auth: auth.data,
})

export default connect(mapState)(OrderConfiguration)



// WEBPACK FOOTER //
// ./src/containers/configurations/Order/OrderByRegion.js